var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-vip-container" },
    [
      _c("sec-title", { attrs: { showHelp: _vm.showHelp } }),
      _vm._v(" "),
      _c(
        "confirm",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowHelp,
              expression: "isShowHelp"
            }
          ],
          staticClass: "small",
          attrs: {
            showMask: true,
            singleBtn: true,
            title: _vm.$t("tradeVip.help.title"),
            closeIcon: true,
            close: _vm.close,
            leftBtnTxt: _vm.$t("btn.understand"),
            leftBtnClick: _vm.close
          }
        },
        [
          _c("div", { staticClass: "help-t" }, [
            _vm._v(_vm._s(_vm.$t("tradeVip.helpConfirm.t1")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt" }, [
            _vm._v(_vm._s(_vm.$t("tradeVip.helpConfirm.txt1")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-t" }, [
            _vm._v(_vm._s(_vm.$t("tradeVip.helpConfirm.t2")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt" }, [
            _vm._v(_vm._s(_vm.$t("tradeVip.helpConfirm.txt2")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt" }, [
            _vm._v(_vm._s(_vm.$t("tradeVip.helpConfirm.txt3")))
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn_group" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isVip,
                expression: "!isVip"
              }
            ],
            staticClass: "__trade-btn __pointer",
            on: { click: _vm.openVIP }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeVip.vipConfirm.openVip")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVip,
                expression: "isVip"
              }
            ],
            staticClass: "__trade-btn unuse"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeVip.vipConfirm.openVip")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "__trade-btn __pointer", on: { click: _vm.openSVIP } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeVip.svipConfirm.openVip")) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("tradeVip.vipListTitle")))
      ]),
      _vm._v(" "),
      _c("vip-list", {
        attrs: {
          showVipConfirm: _vm._showCancelVIP,
          showSVipConfirm: _vm.showCancelSVIPConfirm
        }
      }),
      _vm._v(" "),
      _c("vip-confirm", { ref: "vipConfirm" }),
      _vm._v(" "),
      _c("cancelVIPConfirm", { ref: "cancelVIPConfirm" }),
      _vm._v(" "),
      _c("cancelSVIPConfirm", { ref: "cancelSVIPConfirm" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }